export default __webpack_public_path__ + "static/media/role.09a2ab45.wav";